import { croatianMessages } from './common';

export default {
  'input.placeholder': 'Vaš termin za pretragu / Konfigurator OnlineCode',
  ...croatianMessages,
};
